import { render, staticRenderFns } from "./VideoResourceList.vue?vue&type=template&id=2e0a195e&scoped=true"
import script from "./VideoResourceList.vue?vue&type=script&lang=js"
export * from "./VideoResourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a195e",
  null
  
)

export default component.exports